var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list-form" },
    [
      _c(
        "el-radio-group",
        {
          staticStyle: { "margin-bottom": "30px" },
          attrs: { size: "small" },
          model: {
            value: _vm.activeSetting,
            callback: function ($$v) {
              _vm.activeSetting = $$v
            },
            expression: "activeSetting",
          },
        },
        [
          _c("el-radio-button", { attrs: { label: 1 } }, [_vm._v("内 容")]),
          _vm._v(" "),
          _c("el-radio-button", { attrs: { label: 2 } }, [_vm._v("样 式")]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 1,
              expression: "activeSetting==1",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "100px" },
        },
        [
          _c(
            "draggable",
            {
              on: { end: _vm.onEnd },
              model: {
                value: _vm.itemInfo.movieLists,
                callback: function ($$v) {
                  _vm.$set(_vm.itemInfo, "movieLists", $$v)
                },
                expression: "itemInfo.movieLists",
              },
            },
            _vm._l(_vm.itemInfo.movieLists, function (item, index) {
              return _c(
                "el-card",
                { key: index, staticStyle: { "margin-bottom": "15px" } },
                [
                  _c(
                    "el-form",
                    { attrs: { model: item, "label-width": "100px" } },
                    [
                      _c("el-form-item", { attrs: { label: "上传视频：" } }, [
                        _vm.userType === 1
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  width: "100px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "upLoadPicBox",
                                    on: {
                                      click: function ($event) {
                                        return _vm.modalPicTap(
                                          "1",
                                          "pic",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    item.pic
                                      ? _c("div", { staticClass: "pictrue" }, [
                                          _c("video", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                            },
                                            attrs: { src: item.pic },
                                          }),
                                        ])
                                      : _c("div", { staticClass: "upLoad" }, [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-camera cameraIconfont",
                                          }),
                                        ]),
                                  ]
                                ),
                                _vm._v(" "),
                                item.pic
                                  ? _c("i", {
                                      staticClass: "el-icon-delete",
                                      staticStyle: {
                                        color: "red",
                                        "font-size": "16px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeImg("pic", index)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticClass: "avatar-uploader-small",
                                    attrs: {
                                      action: "",
                                      "show-file-list": false,
                                      "http-request": function (options) {
                                        return _vm.handleLocalUpload(
                                          options,
                                          "pic",
                                          index
                                        )
                                      },
                                      "before-upload": _vm.beforeUpload,
                                      accept: "video/*",
                                    },
                                  },
                                  [
                                    item.pic
                                      ? _c("video", {
                                          staticClass: "avatar-small",
                                          attrs: { src: item.pic },
                                        })
                                      : _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon-small",
                                        }),
                                  ]
                                ),
                                _vm._v(" "),
                                item.pic
                                  ? _c("i", {
                                      staticClass: "el-icon-delete",
                                      staticStyle: {
                                        color: "red",
                                        "font-size": "16px",
                                        "margin-left": "10px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeImg("pic", index)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                      ]),
                      _vm._v(" "),
                      _c("el-form-item", { attrs: { label: "封面图片：" } }, [
                        _vm.userType === 1
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  width: "100px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "upLoadPicBox",
                                    on: {
                                      click: function ($event) {
                                        return _vm.modalPicTap(
                                          "1",
                                          "coverImg",
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [
                                    item.coverImg
                                      ? _c("div", { staticClass: "pictrue" }, [
                                          _c("video", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                            },
                                            attrs: { src: item.coverImg },
                                          }),
                                        ])
                                      : _c("div", { staticClass: "upLoad" }, [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-camera cameraIconfont",
                                          }),
                                        ]),
                                  ]
                                ),
                                _vm._v(" "),
                                item.coverImg
                                  ? _c("i", {
                                      staticClass: "el-icon-delete",
                                      staticStyle: {
                                        color: "red",
                                        "font-size": "16px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeImg(
                                            "coverImg",
                                            index
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticClass: "avatar-uploader-small",
                                    attrs: {
                                      action: "",
                                      "show-file-list": false,
                                      "http-request": function (options) {
                                        return _vm.handleLocalUpload(
                                          options,
                                          "coverImg",
                                          index
                                        )
                                      },
                                      "before-upload": _vm.beforeUpload,
                                      accept: "image/*",
                                    },
                                  },
                                  [
                                    item.coverImg
                                      ? _c("img", {
                                          staticClass: "avatar-small",
                                          attrs: { src: item.coverImg },
                                        })
                                      : _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon-small",
                                        }),
                                  ]
                                ),
                                _vm._v(" "),
                                item.coverImg
                                  ? _c("i", {
                                      staticClass: "el-icon-delete",
                                      staticStyle: {
                                        color: "red",
                                        "font-size": "16px",
                                        "margin-left": "10px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeImg(
                                            "coverImg",
                                            index
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "标题：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "220px" },
                            attrs: { placeholder: "请输入", min: 0 },
                            on: { blur: _vm.updateItem },
                            model: {
                              value: item.name,
                              callback: function ($$v) {
                                _vm.$set(item, "name", $$v)
                              },
                              expression: "item.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "链接：" } },
                        [
                          _c("JumpNative", {
                            staticStyle: { width: "220px" },
                            model: {
                              value: item.url,
                              callback: function ($$v) {
                                _vm.$set(item, "url", $$v)
                              },
                              expression: "item.url",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "add-btn",
              staticStyle: { width: "100%" },
              attrs: { type: "primary" },
              on: { click: _vm.addMovieContent },
            },
            [_vm._v("添加内容")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeSetting == 2,
              expression: "activeSetting==2",
            },
          ],
          attrs: { model: _vm.itemInfo, "label-width": "100px" },
        },
        [
          _c("el-form-item", { attrs: { label: "背景图片：" } }, [
            _vm.userType === 1
              ? _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "upLoadPicBox",
                        on: {
                          click: function ($event) {
                            return _vm.modalPicTap("1", "bgImg")
                          },
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("div", { staticClass: "pictrue" }, [
                              _c("img", { attrs: { src: _vm.itemInfo.bgImg } }),
                            ])
                          : _c("div", { staticClass: "upLoad" }, [
                              _c("i", {
                                staticClass: "el-icon-camera cameraIconfont",
                              }),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: { color: "red", "font-size": "16px" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("image", -1)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              : _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: "",
                          "show-file-list": false,
                          "http-request": function (options) {
                            return _vm.handleLocalUpload(options, "bgImg")
                          },
                          "before-upload": _vm.beforeUpload,
                          accept: "image/*",
                        },
                      },
                      [
                        _vm.itemInfo.bgImg
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.itemInfo.bgImg },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.itemInfo.bgImg
                      ? _c("i", {
                          staticClass: "el-icon-delete",
                          staticStyle: {
                            color: "red",
                            "font-size": "20px",
                            "margin-left": "10px",
                            cursor: "pointer",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg("image", -1)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "upload-tip",
                        staticStyle: { "margin-left": "10px" },
                      },
                      [_vm._v("支持jpg、png格式，不超过2MB")]
                    ),
                  ],
                  1
                ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "背景色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.bgColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "bgColor", $$v)
                  },
                  expression: "itemInfo.bgColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "图标颜色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.titleColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "titleColor", $$v)
                  },
                  expression: "itemInfo.titleColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "图标颜色：" } },
            [
              _c("el-color-picker", {
                attrs: { "show-alpha": "" },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.titleColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "titleColor", $$v)
                  },
                  expression: "itemInfo.titleColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "标题位置：" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.titleAlign,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo, "titleAlign", $$v)
                    },
                    expression: "itemInfo.titleAlign",
                  },
                },
                _vm._l(_vm.TITLE_ALIGN_OPTIONS, function (item) {
                  return _c(
                    "el-radio",
                    { key: item.key, attrs: { label: item.key } },
                    [_vm._v(_vm._s(item.name))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "是否显示标题：" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-value": 1,
                  "active-text": "显示",
                  "inactive-text": "隐藏",
                  "inactive-value": 0,
                },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.showTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "showTitle", $$v)
                  },
                  expression: "itemInfo.showTitle",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: "内间距：" } }, [
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("上："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.moviePadding.pt,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.moviePadding, "pt", $$v)
                    },
                    expression: "itemInfo.moviePadding.pt",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("下："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.moviePadding.pb,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.moviePadding, "pb", $$v)
                    },
                    expression: "itemInfo.moviePadding.pb",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("左："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.moviePadding.pl,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.moviePadding, "pl", $$v)
                    },
                    expression: "itemInfo.moviePadding.pl",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex", staticStyle: { "margin-bottom": "5px" } },
              [
                _c("div", { staticStyle: { "margin-right": "10px" } }, [
                  _vm._v("右："),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  attrs: { min: 0 },
                  on: { change: _vm.updateItem },
                  model: {
                    value: _vm.itemInfo.moviePadding.pr,
                    callback: function ($$v) {
                      _vm.$set(_vm.itemInfo.moviePadding, "pr", $$v)
                    },
                    expression: "itemInfo.moviePadding.pr",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "内部间距：" } },
            [
              _c("el-input-number", {
                attrs: { min: 0 },
                on: { change: _vm.updateItem },
                model: {
                  value: _vm.itemInfo.midPadding,
                  callback: function ($$v) {
                    _vm.$set(_vm.itemInfo, "midPadding", $$v)
                  },
                  expression: "itemInfo.midPadding",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }